import LoadingObject, { LoadingObjectType } from '@/components/view/atoms/loading/LoadingObject'
import Area from '@/components/view/layouts/area/Area'
import AreaContent from '@/components/view/layouts/area/AreaContent'
import Content, { ContentType } from '@/components/view/layouts/page/Content'
import ContentSideFrame from '@/components/view/layouts/page/ContentSideFrame'
import Side from '@/components/view/layouts/page/Side'

const FormLoading = () => (
  <Area>
    <AreaContent>
      <LoadingObject type={LoadingObjectType.INPUT_THIN} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT_SHORT} />
    </AreaContent>
  </Area>
)

const SideFormLoading = () => (
  <Area>
    <AreaContent>
      <LoadingObject type={LoadingObjectType.INPUT_THIN} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT} />
      <LoadingObject type={LoadingObjectType.TEXT_SHORT} />
    </AreaContent>
  </Area>
)

interface Props {
  center?: boolean
  withSide?: boolean
}

const ContentEditLoading = ({ center = false, withSide = false }: Props) => {
  return withSide ? (
    <>
      <ContentSideFrame>
        <Content type={center ? ContentType.DEFAULT : ContentType.TWO_COLUMNS_LEFT}>
          <FormLoading />
          <FormLoading />
          <FormLoading />
        </Content>
        <Side>
          <SideFormLoading />
          <SideFormLoading />
        </Side>
      </ContentSideFrame>
    </>
  ) : (
    <Content type={center ? ContentType.DEFAULT : ContentType.TWO_COLUMNS_LEFT}>
      <FormLoading />
      <FormLoading />
      <FormLoading />
    </Content>
  )
}

export default ContentEditLoading
